module.exports = __webpack_public_path__ + "img/order.16f72ec7.jpg";